// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__pYV2A","author":"Table_author__3Y-gZ","authorImage":"Table_authorImage__MkqEI","unreadRow":"Table_unreadRow__4PGR5"};